import { useLocation, useNavigate } from 'react-router-dom';

export default function useQueryLinkNavigate() {
    
    const navigate = useNavigate();
    const pathInfo = useLocation().state;
    const pathname = useLocation().pathname;
    const basePath = pathname.match(/.*\.do/)?.[0] || '/';
    const isHome = pathname === '/';

    const writeTyp = pathname.includes('/edit') ? '02' : pathname.includes('/reply') ? '03' : '01';
    const workBoardTyp = pathInfo?.id === 3004;

    // 쿼리를 가지고 이동하는 페이지
    const returnPage = (pageTyp, newNttSno, newQuery, editCot) => {
        const prevSearch = pathInfo?.prevSearch;

        if(pageTyp === 'list') {
            navigate(`${basePath}${prevSearch ? '?' + prevSearch : ''}`);
        } else if (pageTyp === 'detail') {
            navigate(`${basePath}/${newNttSno}`, { state: {prevSearch: newQuery} });
        } else if (pageTyp === 'write') {
            navigate(`${basePath}/write`, { state: {clickedMenu: true, prevSearch: newQuery} });
        } else if (pageTyp === 'edit') {
            navigate(`${basePath}/edit/${newNttSno}`, { state: {clickedMenu: true, prevSearch: newQuery, contents: editCot} });
        } else if (pageTyp === 'reply') {
            navigate(`${basePath}/reply/${newNttSno}`, { state: {clickedMenu: true, prevSearch: newQuery} });
        } else if (pageTyp === 'org') {
            navigate(`${basePath}/${newNttSno}`, { state: {prevSearch: newQuery} });
        }
    };

    return {
        pathname,
        pathInfo,
        basePath,
        isHome,
        writeTyp,
        workBoardTyp,
        returnPage
    };

}